import script from "./BaseAccountName.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseAccountName.vue?vue&type=script&setup=true&lang=ts"

import "./BaseAccountName.vue?vue&type=style&index=0&id=c92c81ba&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c92c81ba"]])

export default __exports__